import userService from "../../services/user.service";
import {
  ActionTypes,
  VideoLibraryDataTableActionTypes,
} from "../Constants/ActionTypes";

export const toggleAddOrEditBreakDownPopUp = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.TOGGLE_ADD_OR_EDIT_BREAKDOWN,
    payload: payload,
  });
};
export const isEditBreakDownValue = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_EDIT_BREAKDOWN,
    payload: payload,
  });
};

export const setEditBreakDownInformation = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_EDIT_BREAKDOWN_INFORMATION,
    payload: payload,
  });
};

export const resetBreakDownValues = (dispatch) => {
  dispatch({
    type: ActionTypes.RESET_BREAKDOWN_VALUES,
    payload: null,
  });
};

export const setBreakDownList = (dispatch, payload) => {
  const { page, pageSize, currentUserId, defaultColumnSetName } = payload;
  dispatch({
    type: ActionTypes.BREAKDOWN_TABLE_LOADING,
    payload: true,
  });
  userService
    .getDefaultBreakdown(currentUserId, page, pageSize, defaultColumnSetName)
    .then((res) => {
      const data = res?.data?.data;

      let breakdownList = data.breakdownLists.sort(
        (a, b) => a.positionNumber - b.positionNumber
      );

      dispatch({
        type: ActionTypes.BREAKDOWN_TABLE_LOADING,
        payload: false,
      });
      dispatch({
        type: ActionTypes.BREAKDOWN_TABLE_FULL_PAGE_LOADING,
        payload: false,
      });
      dispatch({
        type: ActionTypes.SET_BREAKDOWNTABLE_LIST,
        payload: {
          page: page,
          data: breakdownList ? breakdownList : [],
          totalRecords: data?.total,
          totalPages: data?.totalPages,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.SET_BREAKDOWNTABLE_LIST,
        payload: {
          page: 0,
          data: [],
          totalRecords: 0,
          totalPages: 0,
        },
      });
      dispatch({
        type: ActionTypes.BREAKDOWN_TABLE_FULL_PAGE_LOADING,
        payload: false,
      });
      dispatch({
        type: ActionTypes.BREAKDOWN_TABLE_LOADING,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong While Fetching Breakdown List.",
        },
      });
    });
};

export const setSearchedBreakDownList = (dispatch, payload) => {
  const { query, page, pageSize, schoolId, defaultColumnSetName } = payload;
  dispatch({
    type: ActionTypes.BREAKDOWN_TABLE_LOADING,
    payload: true,
  });
  dispatch({
    type: ActionTypes.SET_SEARCHED_BREAKDOWN_STATUS,
    payload: true,
  });
  userService
    .searchBreakDownData(query, schoolId, page, pageSize, defaultColumnSetName)
    .then((res) => {
      const data = res?.data?.data;
      dispatch({
        type: ActionTypes.BREAKDOWN_TABLE_LOADING,
        payload: false,
      });
      dispatch({
        type: ActionTypes.SET_BREAKDOWNTABLE_LIST,
        payload: {
          page: page,
          data: data?.content ? data?.content : [],
          totalRecords: data?.totalElements,
          totalPages: data?.totalPages,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.BREAKDOWN_TABLE_LOADING,
        payload: false,
      });
      dispatch({
        type: ActionTypes.SET_BREAKDOWNTABLE_LIST,
        payload: {
          page: page,
          data: [],
          totalRecords: 0,
          totalPages: 0,
        },
      });
      dispatch({
        type: ActionTypes.SET_SEARCHED_BREAKDOWN_STATUS,
        payload: true,
      });
    });
};

export const setSearchedBreakdownStatus = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SEARCHED_BREAKDOWN_STATUS,
    payload,
  });
};

export const breakDownTableTableLoading = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.BREAKDOWN_TABLE_FULL_PAGE_LOADING,
    payload,
  });
};

export const updateBreakDown = (dispatch, payload) => {
  const {
    breakDownName,
    breakDownType,
    possibleValue,
    breakDownId,
    schoolId,
    getUpdatedBreakdown,
  } = payload;
  dispatch({
    type: ActionTypes.BREAKDOWN_BUTTON_LOADING,
    payload: {
      field: "addEdit",
      value: true,
    },
  });
  userService
    .requestChangeBreakdownValue(
      schoolId,
      breakDownName,
      possibleValue?.join(","),
      "",
      breakDownId
    )
    .then((res) => {
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Breakdown Added Successfully.",
            open: true,
          },
        },
      });
      dispatch({
        type: VideoLibraryDataTableActionTypes.UPDATE_BREAKDOWN,
        payload: {
          breakDownId,
          breakDownName,
          breakDownType,
          possibleValue,
        },
      });
      //update possible values for autocomplete feature
      dispatch({
        type: VideoLibraryDataTableActionTypes.UPDATE_BREAKDOWN_POSSIBLE_VALUE,
        payload: { possibleValue, breakdownId: breakDownId },
      });
      dispatch({
        type: ActionTypes.SET_EDIT_BREAKDOWN,
        payload: false,
      });
      dispatch({
        type: ActionTypes.TOGGLE_ADD_OR_EDIT_BREAKDOWN,
        payload: false,
      });
      dispatch({
        type: ActionTypes.CLOSE_EDIT_BREAKDOWN_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_OR_CLOSE_BREAKDOWNPOPUP,
        payload: true,
      });
      dispatch({
        type: ActionTypes.UPDATE_BREAKDOWN,
        payload: res?.data?.data,
      });
      dispatch({
        type: ActionTypes.BREAKDOWN_BUTTON_LOADING,
        payload: {
          field: "addEdit",
          value: false,
        },
      });
      //to update data to newly added fields
      getUpdatedBreakdown();
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.BREAKDOWN_BUTTON_LOADING,
        payload: {
          field: "addEdit",
          value: false,
        },
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong While Updating Breakdown.",
        },
      });
    });
};

export const addBreakdown = async (dispatch, payload) => {
  const {
    breakDownName,
    breakDownType,
    possibleValue,
    schoolId,
    columnNameId,
  } = payload;
  dispatch({
    type: ActionTypes.BREAKDOWN_BUTTON_LOADING,
    payload: {
      field: "addEdit",
      value: true,
    },
  });
  return userService
    .addBreakDownColumn(
      breakDownName,
      breakDownType,
      possibleValue?.join(","),
      schoolId,
      columnNameId
    )
    .then((res) => {
      dispatch({
        type: ActionTypes.ADD_BREAKDOWN,
        payload: res?.data?.data,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Breakdown Added Successfully.",
            open: true,
          },
        },
      });
      dispatch({
        type: ActionTypes.TOGGLE_ADD_OR_EDIT_BREAKDOWN,
        payload: false,
      });
      dispatch({
        type: ActionTypes.CLOSE_EDIT_BREAKDOWN_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_OR_CLOSE_BREAKDOWNPOPUP,
        payload: true,
      });
      dispatch({
        type: ActionTypes.BREAKDOWN_BUTTON_LOADING,
        payload: {
          field: "addEdit",
          value: false,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.BREAKDOWN_BUTTON_LOADING,
        payload: {
          field: "addEdit",
          value: false,
        },
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong While Adding Breakdown.",
        },
      });
    });
};

export const deleteBreakdown = (dispatch, payload) => {
  const {
    id,
    breakDownList,
    searchedRecord,
    searchQuery,
    schoolId,
    currentUserId,
  } = payload;
  dispatch({
    type: ActionTypes.BREAKDOWN_BUTTON_LOADING,
    payload: {
      field: "delete",
      value: true,
    },
  });

  userService
    .deletebreakDownId({
      id: id,
    })
    .then(() => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.BREAKDOWN_BUTTON_LOADING,
        payload: {
          field: "delete",
          value: false,
        },
      });
      dispatch({
        type: VideoLibraryDataTableActionTypes.DELETE_BREAKDOWN,
        payload: {
          breakDownId: id,
        },
      });

      const page =
        breakDownList?.data?.length === 1 && breakDownList?.page !== 0
          ? breakDownList?.page - 1
          : breakDownList?.page;

      searchedRecord
        ? setSearchedBreakDownList(dispatch, {
            query: searchQuery,
            schoolId,
            page,
            pageSize: breakDownList?.pageSize,
          })
        : setBreakDownList(dispatch, {
            page,
            pageSize: breakDownList?.pageSize,
            currentUserId,
          });
      dispatch({
        type: ActionTypes.SET_EDIT_BREAKDOWN,
        payload: false,
      });
      dispatch({
        type: ActionTypes.TOGGLE_ADD_OR_EDIT_BREAKDOWN,
        payload: false,
      });
      dispatch({
        type: ActionTypes.CLOSE_EDIT_BREAKDOWN_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Breakdown Deleted Successfully.",
            open: true,
          },
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong While Deleting Breakdown.",
        },
      });
    });
};
